import {Directive, TemplateRef, ViewContainerRef} from '@angular/core';
import {TemplatePortal} from '@angular/cdk/portal';

/**
 * The directive can be used in a ng-template tag to create a template portal.
 * This template portal can be embedded at another place in the page. For example in the overlay component.
 * Have a look at the {@link AbstractPortalToOverlayComponent} for further details.
 *
 * @see TemplatePortal
 */
@Directive({selector: '[appTemplatePortal]'})
export class TemplatePortalDirective extends TemplatePortal {
    constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
        super(templateRef, viewContainerRef);
    }
}
